/**
 * AudioHero Component
 *
 * Hero section for the audio generation page.
 */

import { memo } from 'react';
import { Volume2 } from 'lucide-react';
import { useTranslation } from '@/hooks/useTranslation';

export const AudioHero = memo(function AudioHero() {
  const { t } = useTranslation();
  return (
    <div className="text-center mb-8">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl mb-4">
        <Volume2 className="h-8 w-8 text-white" />
      </div>
      <h2 className="text-3xl font-bold text-secondary-900 mb-2">{t('audioPage.hero.title')}</h2>
      <p className="text-lg text-secondary-600 max-w-2xl mx-auto">{t('audioPage.hero.subtitle')}</p>
    </div>
  );
});
